export default __webpack_public_path__ + "static/media/485.fbe8f528.jpg";